import { uuid } from "../uuid";

export const roomContextId = uuid;
